import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { PhoneVerificationComponent } from './pages/phone-verification/phone-verification.component';
import { PhoneNumberComponent } from './pages/forgot-pin/phone-number/phone-number.component';
import { SecurityVerificationComponent } from './pages/forgot-pin/security-verification/security-verification.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ResetProcessComponent } from './pages/forgot-pin/reset-process/reset-process.component';
import { LockedAccountGuard } from './guards/locked-account.guard';

let authRoutes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    canActivateChild: [AuthGuard, LockedAccountGuard],
    children: [
      { path: 'login', component: LoginComponent, data: { title: 'Login to your account' } },
      // signup is disabled for now, redirects to login
      { path: 'signup', redirectTo: 'login' },
      { path: 'signup/:code', redirectTo: 'login' },
      // { path: 'signup', component: SignupComponent, data: { title: 'Create an account' } },
      // { path: 'signup/:code', component: SignupComponent, data: { title: 'Create an account' } },
      {
        path: 'phone-verification',
        component: PhoneVerificationComponent,
        data: { title: "Verify it's you", customLayout: true, animation: 'One' },
      },
      { path: 'phone-number', component: PhoneNumberComponent, data: { title: 'Reset  PIN' } },
      {
        path: 'security-verification',
        component: SecurityVerificationComponent,
        data: { title: "Verify it's you", customLayout: true },
      },
      {
        path: 'pin-reset',
        component: ResetProcessComponent,
        data: { customLayout: true },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  providers: [AuthGuard],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
